export default __webpack_public_path__ + "static/best-logo-design-award-work-07dd6de88cf671ab081c9215459fcdfb.jpg";